import React, { useContext, useState } from 'react';
import { Button } from 'edozvola-frontend-lib/dist/ui';
import CaseAttachmentTable from 'app/edozvola/cases/case-attachment/case-attachment-table';
import CaseAttachmentAddForm from 'app/edozvola/cases/case-attachment/case-attachment-add-form';
import { CaseTabContext } from 'app/edozvola/cases/case-form-wrapper';
import { getCaseContext } from 'app/shared/util/context-util';

const CaseAttachment = () => {
  const [idCaseAttachment, setIdCaseAttachment] = useState<string | null>(null);
  const [readOnly, setReadOnly] = useState(false);
  const { sidebarItemPair } = getCaseContext();

  const onRowClick = (idCaseAttachment: string, readOnly: boolean) => {
    setIdCaseAttachment(idCaseAttachment);
    setReadOnly(readOnly);
  };

  return (
    <>
      <>
        <h6 className={'form-header'}>Prilozi zahtjevu</h6>
        <div className={'d-flex justify-content-between flex-row-reverse'}>
          {!sidebarItemPair?.readOnly && (
            <Button label="Dodaj prilog" color="info" size="lg" prependIcon={'plus'} onClick={() => onRowClick('', false)} />
          )}
        </div>
        <div className={'mt-3'}>
          <CaseAttachmentTable onRowClick={onRowClick} />
        </div>
      </>
      {idCaseAttachment !== null && (
        <CaseAttachmentAddForm setIdCaseAttachment={setIdCaseAttachment} idCaseAttachment={idCaseAttachment} readOnly={readOnly} />
      )}
    </>
  );
};

export default CaseAttachment;
